'use client';

import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import Button from '@sympla/sympla-components/Button';
import { Location } from 'location.d';
import { ANYWHERE_LOCATION, NEAR_TO_YOU_LABEL } from 'constants/index';
import locationStore from 'stores/LocationStore';

import * as styles from './SearchResultInfo.css';

type SearchResultInfoProps = {
  pageTypeText: string;
  numberOfEvents: number;
  currentPage: number;
  totalPages: number;
  location: Location;
};

function SearchResultInfo({
  pageTypeText,
  numberOfEvents,
  currentPage,
  totalPages,
  location,
}: SearchResultInfoProps) {
  const foundEventsText = useMemo(() => {
    const texts = {
      [ANYWHERE_LOCATION]: `${numberOfEvents} ${pageTypeText} encontrados`,
      [NEAR_TO_YOU_LABEL]: (
        <>
          {`${numberOfEvents} ${pageTypeText} encontrados`}
          <strong> perto de você</strong>
        </>
      ),
      default: (
        <>
          {`${numberOfEvents} ${pageTypeText} em `}
          <strong>{location.city}</strong>
          {' '}
          e região
        </>
      ),
    };

    return texts[location.city as keyof typeof texts] ?? texts.default;
  }, [numberOfEvents, location]);

  return (
    <>
      <div className={styles.Wrapper}>
        <p className={styles.TextStyles}>{foundEventsText || `${numberOfEvents} ${pageTypeText} encontrados`}</p>
        {location.city !== ANYWHERE_LOCATION && (
          <div className={styles.ChangeLocation}>
            A busca não é nessa localização?
            <Button variant="text" size="medium" upperCase={false} onClick={() => locationStore.setIsLocationModalVisible(true)}>
              Trocar
            </Button>
          </div>
        )}
      </div>
      {!!numberOfEvents && (
        <p className={`${styles.TextStyles} ${styles.TextPaginationStyles}`}>
          <span>Página </span>
          <strong>{currentPage}</strong>
          <span>{` de ${totalPages}`}</span>
        </p>
      )}
    </>
  );
}

export default observer(SearchResultInfo);
